import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
    padding: 0px 0px 0px 0px;
    background-color: #ffffff;
    height: 100%;
`;
